import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["platform", "tagName"];
import React from 'react';
import { getPlatformKey } from './utils';
export const CommonTypography = props => {
  const {
      platform,
      tagName: Tag = 'div'
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React.createElement(Tag, Object.assign({
    "data-tui-typography": getPlatformKey(platform)
  }, restProps));
};